import {
  Component,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes, faLayerGroup } from '@fortawesome/free-solid-svg-icons';

import { InputComponent } from '../input/input.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-section-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    FontAwesomeModule,
    InputComponent,
    ButtonComponent
],
  templateUrl: './section-modal.component.html',
  styleUrls: ['./section-modal.component.scss'],
})
export class SectionModalComponent implements OnInit, OnDestroy {
  @Input() active: boolean = true;
  @Input() control: FormControl = new FormControl();
  @Input() title?: string;

  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<void>();

  icons = { cancel: faTimes, section: faLayerGroup };

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit() {
    if (typeof document !== 'undefined') {
      document.body.appendChild(this.el.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.el.nativeElement.parentNode) {
      this.el.nativeElement.parentNode.removeChild(this.el.nativeElement);
    }
  }

  onClose(): void {
    this.close.emit();
  }

  onSubmit(): void {
    if (this.control.invalid) return;
    this.submit.emit();
  }
}
